var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDineIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 7.875H11.25V6.75C11.25 4.125 9.28125 1.94531 6.75 1.57031V1.125H7.875C8.0625 1.125 8.25 0.960938 8.25 0.75V0.375C8.25 0.1875 8.0625 0 7.875 0H4.125C3.91406 0 3.75 0.1875 3.75 0.375V0.75C3.75 0.960938 3.91406 1.125 4.125 1.125H5.25V1.57031C2.69531 1.94531 0.75 4.125 0.75 6.75V7.875H0.375C0.164062 7.875 0 8.0625 0 8.25V8.625C0 8.83594 0.164062 9 0.375 9H11.625C11.8125 9 12 8.83594 12 8.625V8.25C12 8.0625 11.8125 7.875 11.625 7.875ZM10.125 7.875H1.875V6.75C1.875 4.47656 3.70312 2.625 6 2.625C8.27344 2.625 10.125 4.47656 10.125 6.75V7.875Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineIn);
export default __webpack_public_path__ + "static/media/dine_in.dc651ece.svg";
export { ForwardRef as ReactComponent };